/* eslint-disable */
// @ts-nocheck

import { defineStore } from "pinia";

export const useSidePanelStore = defineStore({
  id: "sidePanelStore",
  state: () =>
    ({
      userManualSearch: false,
      panelWidth: "500px",
      addQuantity: 1,
    }) as any,
  getters: {
    getUserManualSearch(): boolean {
      return this.userManualSearch;
    }
  },
  actions: {
    setUserManualSearch(flag: boolean): null {
      this.userManualSearch = flag;
    },
    unsetUserManualSearch(): null {
      this.userManualSearch = false;
    },
    flipUserManualSearch(): boolean {
      this.userManualSearch = !this.userManualSearch;

      return this.userManualSearch;
    },
    setPanelWidth(width: string): null {
      this.panelWidth = width;
    },
    resetAddQuantity(): null {
      this.addQuantity = 1;
    },
    setAddQuantity(quantity: number): null {
      this.addQuantity = quantity;
    },
  }
});
